module.exports = __webpack_public_path__ + "img/beefuser.abe8fae9.png";